import styled from 'styled-components';

export const CenterWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  padding: 0.75rem 0;
`;

export const ErrorMessage = styled.span`
  font-size: 0.875rem;
  margin-bottom: 2.5rem;
`;
